import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectFeatureFlags, selectIsBossOrSalesBossLevel } from 'core/userContext';
import { SendingPlatform } from 'modules/sendingPlatforms/constants';
import { spacing, H4 } from 'ui/theme';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { Add24 } from 'ui/icons';
import { useModalsContext, useSendingPlatformsQueryContext } from '../../../contexts';
import { isIterableSMSSendingPlatform } from '../../../utils';

export const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing.plusHalf};
  white-space: nowrap;
`;

export const Heading = styled(H4)`
  margin-bottom: 0;
  margin-right: ${spacing.base};
`;

export const SmsAccountsHeader = ({ sendingPlatform }: { sendingPlatform: SendingPlatform }) => {
  const { showCreateAccountModal } = useModalsContext();
  const { hasEspAccounts } = useSendingPlatformsQueryContext();
  const isBossOrSalesBossLevel = useSelector(selectIsBossOrSalesBossLevel);
  const { SMSSelfServeAccountSetupUI } = useSelector(selectFeatureFlags);

  const isIterableSMS = isIterableSMSSendingPlatform(sendingPlatform);

  const isDisabled = isIterableSMS
    ? !SMSSelfServeAccountSetupUI || !isBossOrSalesBossLevel // Iterable SMS enablement requires Boss
    : !SMSSelfServeAccountSetupUI && !hasEspAccounts(sendingPlatform); // If a customer is already enabled, they can add more accounts

  return (
    <Header data-test="sending-platform-details-accounts-header">
      <Heading>Accounts</Heading>
      <PrimaryButton
        size={BUTTON_SIZES.LARGE}
        onClick={() => showCreateAccountModal(sendingPlatform)}
        isDisabled={isDisabled}
      >
        <Add24 />
        <span>Add account</span>
      </PrimaryButton>
    </Header>
  );
};
